var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [{ name: "modal", rawName: "v-modal" }],
      staticClass: "modal",
      class: _vm.style.container,
      attrs: { "data-backdrop": "static", tabindex: "-1", role: "dialog" },
    },
    [
      _c("div", { class: _vm.style.modal, attrs: { role: "document" } }, [
        _c(
          "div",
          { staticClass: "modal-content", class: _vm.style.content },
          [
            _vm.display.header
              ? _c(
                  "div",
                  {
                    staticClass: "modal-header sub-page bg-white type01",
                    class: _vm.style.header,
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "page-title pb-0",
                        class: _vm.style.title,
                      },
                      [
                        _vm.display.back
                          ? _vm._t("backBtn", function () {
                              return [_vm._m(0)]
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("title", function () {
                          return [
                            _vm.text.title
                              ? _c("p", {
                                  staticClass: "h6 title",
                                  domProps: {
                                    textContent: _vm._s(_vm.text.title),
                                  },
                                })
                              : _vm._e(),
                          ]
                        }),
                        _vm._v(" "),
                        _vm.display.close
                          ? _vm._t("closeBtn", function () {
                              return [_vm._m(1)]
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body", class: _vm.style.body },
              [_vm._t("contents")],
              2
            ),
            _vm._v(" "),
            _vm.display.footer
              ? _vm._t("footer", function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "modal-footer", class: _vm.style.footer },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _vm.display.cancel
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-cancel text-color6 px-3 py-0",
                                  class: _vm.style.cancel,
                                  attrs: {
                                    type: "button",
                                    "data-dismiss": _vm.dismiss.cancel
                                      ? "modal"
                                      : "",
                                  },
                                  domProps: {
                                    textContent: _vm._s(_vm.text.cancel),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$emit("cancel")
                                    },
                                  },
                                },
                                [_vm._v("\n              Close\n            ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.display.confirm
                            ? _c("button", {
                                staticClass:
                                  "btn btn-confirm text-color4 px-3 py-0",
                                class: _vm.style.confirm,
                                attrs: {
                                  type: "button",
                                  "data-dismiss": _vm.dismiss.confirm
                                    ? "modal"
                                    : "",
                                },
                                domProps: {
                                  textContent: _vm._s(_vm.text.confirm),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.$emit("confirm")
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                })
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn page-back",
        attrs: {
          "data-dismiss": "modal",
          "aria-label": "Close",
          href: "javascript:void(0)",
        },
      },
      [_c("i", { staticClass: "fa fa-angle-left" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }